<template>
  <BasePage>
    <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
           <component :is="Component" />
        </transition>
      </router-view>
  </BasePage>
</template>

<script setup>
    import { useRoute } from 'vue-router'
    const route = useRoute();
    import { watch } from 'vue';
    import BasePage from '@/components/basePage/index.vue'

    // 获取当前语言
    const language = localStorage.getItem("language") || "zh"
    // 语言包 修改网页标题
    import(`@/language/${language}.js`).then(data => {
        document.title = data.default.title;
    }) 

    watch(
        () => route.fullPath,
        () => {   
            // 链接带language参数时，切换语言
            console.log('language', route.query.language)
            const newLanguage = route.query.language 

            if(newLanguage && ["zh", "zt", "en"].includes(newLanguage)) {
              localStorage.setItem("language", newLanguage);
              if(language != newLanguage) window.location.reload()
            }
        }
    )

</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
